<template>
  <InnerCardInfo
    v-if="tax_data"
    :label="localStorage.translations.pages['setting-personal_area'].labels['nalogovyy-nomer']"
    :images="tax_data.image"
    need-image-domain
    :data="[
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['nalogovyy-nomer'],
        value: text || '-',
      },
    ]"
    ref="inner"
    :editReady="editReady"
  >
    <template slot="edit_block">
      <slot/>
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo'
export default {
  name: 'TaxNumberPdf',
  props: {
    editReady: Boolean,
    tax_data: Object
  },
  components: { InnerCardInfo },
  data: () => ({
    file: '',
    imgUrl: null,
    text: null,
    image: [],
  }),
  watch: {
    tax_data() {
      if (this.tax_data) {
        this.text = this.tax_data.text
        if (this.tax_data.image !== undefined) {
          this.image = this.tax_data.image
        }
      }
    },
  },
  mounted() {
    if (this.tax_data) {
      this.text = this.tax_data.text
      if (this.tax_data.image !== undefined) {
        this.image = this.tax_data.image
      }
    }
  },
}
</script>
